import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FastImage from 'react-native-fast-image';

export const Card = styled.View.attrs({
  shadowColor: '#000',
  shadowOffset: {width: 0, height: 4},
  shadowOpacity: 0.1,
  shadowRadius: 4,
  elevation: 3,
})`
  width: 100%;
  border-radius: 16px;
  background-color: ${({theme}) => theme.colors.background};
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border_light};
  padding: 12px;
  align-self: center;
  margin-bottom: 24px;
  flex-direction: column;
`;

//@ts-ignore
export const BrandImage = styled(FastImage)`
  width: ${RFValue(34)}px;
  height: ${RFValue(20)}px;
  border-radius: ${RFValue(4)}px;
  margin-right: ${RFValue(12)}px;
`;
export const CardInfosContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const CardDetails = styled.View`
  flex-grow: 1;
  justify-content: flex-end;
`;

export const CardNumber = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-weight: 500;
`;

export const CardInfos = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${RFValue(4)}px;
`;
export const CardOwner = styled.Text`
  font-weight: 700;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;
export const TaxDetails = styled.View<{ hasCard?: boolean }>`
  flex-grow: 1;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;

  margin-top: ${({ hasCard = true }) => hasCard ? RFValue(6) : 0}px;
  padding-top: ${({ hasCard = true }) => hasCard ? RFValue(6) : 0}px;
  border-style: solid;
  border-top-width: ${({ hasCard = true }) => hasCard ? 1 : 0}px;
  border-top-color: ${({theme}) => theme.colors.border};
`;

export const TaxLabel = styled.Text`
  font-weight: 700;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const TaxValue = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-weight: 500;
`;
